import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import GroupedRow from './GroupedRow';
const GroupedRows = ({ columns, groupedRows, render, selectable, getRowId, onCheckboxChange, selectedIds, onHeaderSelect, }) => {
    return (_jsx(_Fragment, { children: Object.keys(groupedRows).map((item, idx) => (_jsx(GroupedRow, { columns: columns, data: groupedRows[item], label: item, render: render, selectable: selectable, getRowId: getRowId, onCheckboxChange: onCheckboxChange, selectedIds: selectedIds, onHeaderSelect: onHeaderSelect }, `${idx}`))) }));
};
export default GroupedRows;
